export function parseHTML(htmlString) {
  return { __html: htmlString };
}

export function isNotEmpty(value) {
  if (value === null || value === undefined) {
    return false;
  }
  if (typeof value === "string" || Array.isArray(value)) {
    return value.length > 0;
  }
  if (typeof value === "object") {
    return Object.keys(value).length > 0;
  }
  return false; // Return false for other types
}

export const STRAPI_ASSETS_BASE_PATH =
  " https://primary-assets.heartfulness.org/strapi-assets/";